const moment = require('moment');
const defaultState = {
    is: [],
    isDetail: {},
    loading: false,
    loadingHist: false,
    errors:{},
    lastFiltersIS:[],
    isHist:[],
    fpSeries: [],
    fpSeriesLoading: false,
    fpSeriesErrors:{},
    isLatestMsgs: ''
}
  
export default (state=defaultState, action={}) => {
    switch (action.type) {

        case 'FETCH_IS_FULFILLED': {       
            let arrayMain=[];
            let newItem = {};
            
            if(Array.isArray(action.payload.data)){
                action.payload.data.forEach((element,index) => {
                    newItem = {};
                    newItem = element;//limpa para criar um novo
                    newItem["BEGIN_DATETIME_LOCAL"] = moment.utc(element.BEGIN_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                    newItem["END_DATETIME_LOCAL"] = moment.utc(element.END_DATETIME, 'YYYY-MM-DD HH:mm').tz(element.TIMEZONE).format('YYYY-MM-DD HH:mm');
                    //fazer set de state destes valores como auxiliares para criar valdiações
                    arrayMain.push(newItem);
                });
            }else{
                console.log('FETCH_IS_FULFILLED error: ');
                console.dir(action.payload.data);
            }
            
            return {
                ...state,
                is: arrayMain,
                loading: false,
                errors: {}
            }
        }
    
        case 'FETCH_IS_PENDING': {
            return {
                ...state,
                loading: true,
                errors: {}
            }
        }
    
        case 'FETCH_IS_REJECTED': {
            return {
                ...state,
                loading: false,
                errors: { global: action.payload.message }
            }
        }
    
        case 'FETCH_IS_DETAIL_FULFILLED': {
        
            const id = action.payload.data[0].ID;
            const status = action.payload.data[0].STATUS;
            
            return {
                ...state,
                isDetail: action.payload.data[0],
                is: state.is.map(item => item.ID === id ? {...item, STATUS: status} : item),
                errors: {},
                loadingHist: false
            }
        }

        case 'FETCH_IS_DETAIL_PENDING': {
            return {
                ...state,
                loadingHist: true,
                isDetail: {},
                errors: {}
            }
        }
        
        case 'FETCH_IS_DETAIL_REJECTED': {
            return {
                ...state,
                loadingHist: false,
                errors: { global: action.payload.message }
            }
        }      

        case 'LASTFILTER_IS': {      
            return {
                ...state,
                lastFiltersIS: action.payload
            }
        }

        case 'FETCH_IS_HISTORY_FULFILLED': {
            return {
                ...state,
                isHist: action.payload.data,
                loadingHist: false,
                errors: {}
            }
        }
    
        case 'FETCH_IS_HISTORY_PENDING': {
            return {
                ...state,
                loadingHist: true,
                errors: {}
            }
        }
    
        case 'FETCH_IS_HISTORY_REJECTED': {
            return {
                ...state,
                loadingHist: false,
                errors: { global: action.payload.message }
            }
        }       

        case 'FETCH_FP_SERIES_FULFILLED': {
            
            return {
                ...state,
                fpSeries: action.payload.data,
                fpSeriesErrors: {},
                fpSeriesLoading: false
            }
        }

        case 'FETCH_FP_SERIES_PENDING': {
            return {
                ...state,
                fpSeriesLoading: true,
                fpSeriesErrors: {}
            }
        }
        
        case 'FETCH_FP_SERIES_REJECTED': {
            return {
                ...state,
                fpSeriesLoading: false,
                fpSeriesErrors: { global: action.payload.message }
            }
        }

        case 'FETCH_IS_MSG_VERSION_FULFILLED': {
            
            //console.dir(action.payload.data)
            return {
                ...state,
                isLatestMsgs: action.payload.data
            }
        }

        //cases de refresh do state com base em sockets emitidos pelo server
        case 'DELETE_IS_FULFILLED': {
            const id = action.id;
            return {
                ...state,
                is: state.is.filter(item => item.ID !== id)
            }
        }

        case 'EDIT_IS_FULFILLED': {

            const id = action.editedRecord.ID;
            const auxEditedRecord = action.editedRecord;
            return {
                ...state,
                is: state.is.map(item => item.ID === id 
                    ? auxEditedRecord 
                    : item
                )
            }
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/is-reducer.js